import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TreePalm } from "lucide-react";
import {
  Create,
  DateInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "../common";

const typeChoices = [
  { id: "public", name: "Public" },
  { id: "optional", name: "Optional" },
  { id: "company", name: "Company" },
];

export const HolidayCreate = () => (
  <Create title="Create Holiday">
    <SimpleForm className="max-w-3xl mx-auto space-y-6">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <TreePalm className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">Add New Holiday</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <DateInput source="date" />
            <SelectInput source="type" choices={typeChoices} defaultValue="public" />
          </div>
          <div className="mt-4">
            <TextInput source="name" fullWidth />
          </div>
        </CardContent>
      </Card>
    </SimpleForm>
  </Create>
);
